<div class="card">
    <div class="p-datatable p-component p-datatable-hoverable-rows">
        <div class="p-datatable-header">
            <div class="flex align-items-center justify-content-between">
                <div *ngIf="authGuardService.hasPermission('PERMISSION_MANAGE_ALARMS')" class="flex flex-column md:flex-row">
                    <button [label]="'common.new' | transloco" pButton
                        class="md:mr-2 p-button-primary mb-2 md:mb-0" routerLink="new" icon="pi pi-plus"></button>
                </div>
                <div class="flex flex-column md:flex-row justify-content-end">
                    <button (click)="filtersVisible = !filtersVisible" class="p-button-secondary" icon="pi pi-sliders-h"
                        label=" {{'common.filters' | transloco}}" pButton></button>
                </div>
            </div>
        </div>
        <p-table [value]="alarms" [lazy]="true" [responsive]="true" (onLazyLoad)="onPageChange($event)"
                 [paginator]="true" [(rows)]="rows" [totalRecords]="totalAlarms" styleClass="p-datatable-striped"
                 [rowsPerPageOptions]="[10,25,50]" [(first)]="first">
            <ng-template pTemplate="header">
                <tr>
                    <th scope="col">
                        {{'attribute.name' | transloco}}
                    </th>
                    <th scope="col">
                      {{'attribute.alarmType' | transloco}}
                    </th>
                    <th scope="col">
                        {{'attribute.sensor' | transloco}}
                    </th>
                    <th scope="col">
                        {{'attribute.condition' | transloco}}
                    </th>
                    <th scope="col">
                        {{'attribute.timer' | transloco}}
                    </th>
                    <th scope="col">
                        {{'attribute.organizationOwner' | transloco}}
                    </th>
                    <th scope="col">
                        {{'attribute.organizationsAllowed' | transloco}}
                    </th>
                    <th scope="col" *ngIf="authGuardService.hasPermission('PERMISSION_MANAGE_ALARMS')" style="width: 10rem;"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-alarm>
                <tr *ngIf="!loadingAlarms">
                    <td>
                        <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                        {{alarm.name}}
                    </td>
                    <td>
                      <span class="p-column-title bold">{{'attribute.alarmType' | transloco}}</span>
                      <ng-container *ngIf="alarm.alarmType != null">
                        {{ 'common.' + alarm.alarmType.toLowerCase() | transloco }}
                      </ng-container>
                      <p-tag *ngIf="alarm.global && this.userOrganization && this.userOrganization.organizationType.root == true"
                             class="list-tag ml-2" value="{{'attribute.global' | transloco}}"></p-tag>
                    </td>
                    <td>
                        <span class="p-column-title bold">{{'attribute.sensor' | transloco}}</span>
                        {{alarm.deviceMeasurement}}
                    </td>
                    <td>
                        <span class="p-column-title bold">{{'attribute.condition' | transloco}}</span>
                        {{this.operationsTranslation[alarm.operation]}} ({{alarm.value}})
                    </td>
                    <td>
                        <span class="p-column-title bold">{{'attribute.timer' | transloco}}</span>
                        {{alarm.timeWindow}}
                    </td>
                    <td>
                        <span class="p-column-title bold">{{'attribute.organizationOwner' | transloco}}</span>
                        {{alarm.organizationOwner.name}} ({{alarm.organizationOwner.orgCode}})
                    </td>
                    <td>
                        <span class="p-column-title bold">{{'attribute.organizationsAllowed' |
                            transloco}}</span>
                        {{ this.mapProperty(alarm.organizationsAllowed, 'name').join(', ') }}
                    </td>
                    <td *ngIf="authGuardService.hasPermission('PERMISSION_MANAGE_ALARMS')">
                      <span class="p-column-title bold"></span>
                      <div class="flex justify-content-end">
                        <button [routerLink]="alarm.alarmDefinitionUuid + '/edit'" pButton pRipple
                                class="p-button-rounded btn-primary-light mr-2" icon="pi pi-pencil"
                                [disabled]="alarm.readOnly"></button>
                        <button (click)="confirmAndDelete(alarm)" pButton pRipple class="p-button-rounded btn-danger-light"
                                icon="pi pi-trash" [disabled]="alarm.readOnly"></button>
                      </div>
                    </td>
                </tr>
                <tr *ngIf="loadingAlarms">
                    <td class="row-height">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                    <td class="row-height">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                    <td class="row-height">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                    <td class="row-height">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                    <td class="row-height">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                    <td class="row-height">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                    <td class="row-height">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                    <td class="row-height">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                    <td *ngIf="authGuardService.hasPermission('PERMISSION_MANAGE_ALARMS')" class="row-height w-10rem">
                        <p-skeleton height="1em"></p-skeleton>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="flex align-items-center justify-content-between" *ngIf="alarms.length == 0">
                    {{'pagination.empty'
                    | transloco}}</div>
                <div class="flex align-items-center justify-content-between" *ngIf="totalAlarms > 0">
                    {{'pagination.showing' | transloco}} {{first + 1}}
                    {{'pagination.to' | transloco}} {{(first + rows) >= totalAlarms ? totalAlarms : (first +
                    rows)}}
                    {{'pagination.of' | transloco}} {{totalAlarms}}
                    {{(totalAlarms > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
                </div>
            </ng-template>
        </p-table>
    </div>
</div>

<p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
    <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
    <div>
        <div class="col-12">
            <div class="col-12 form-field">
                <label for="name">{{'attribute.name' | transloco}}</label>
            </div>
            <div class="col-12 form-field">
                <input appAutoFocus [focus]="filtersVisible" class="w-full" id="name" type="text" pInputText
                    [(ngModel)]="currentFilters.name" (keyup.enter)="filtersVisible = false; applyFilters()">
            </div>
        </div>
        <div class="col-12">
            <div class="form-field col-12">
                <label for="sensors">{{'attribute.sensor' | transloco}}</label>
            </div>
            <div class="col-12 form-field">
                <p-multiSelect [placeholder]="'select.generic' | transloco" [options]="this.deviceMeasurements"
                    [(ngModel)]="currentFilters.sensors" class="w-full" styleClass="w-full" id="sensors" appendTo="body">
                </p-multiSelect>
            </div>
        </div>
        <div class="col-12">
            <div class="form-field col-12">
                <label for="operations">{{'attribute.operation' | transloco}}</label>
            </div>
            <div class="col-12 form-field">
                <p-multiSelect [placeholder]="'select.generic' | transloco" [options]="this.operationOptions"
                    [(ngModel)]="currentFilters.operations" class="w-full" optionLabel="label" optionValue="value"
                    styleClass="w-full" id="operations" appendTo="body"></p-multiSelect>
            </div>
        </div>
        <div class="col-12">
            <p-button type="button" (onClick)="filtersVisible = false; applyFilters()"
                label="{{'common.filter' | transloco}}" styleClass="p-button-primary mx-2 mt-2"
                [disabled]="!(currentFilters.name ||
                  currentFilters.sensors ||
                  currentFilters.operations)">
            </p-button>
            <p-button type="button" (click)="resetFilters(); filtersVisible = false; applyFilters()"
                label="{{'common.clear' | transloco}}" styleClass="p-button-danger"></p-button>
        </div>
    </div>
</p-sidebar>
